/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
export function IntegrationsInstall({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.2} d="M10.696 12.875c1.204 0 1.204-1.204 1.248-1.214l-.044-1.018v-.712h.975a1.625 1.625 0 1 0 0-3.25H11.9c0-.908 0-1.363-.148-1.721a1.95 1.95 0 0 0-1.056-1.055c-.358-.149-.812-.149-1.721-.149h-.65v-.975a1.625 1.625 0 0 0-3.25 0v.975h-.65c-.909 0-1.363 0-1.721.149A1.95 1.95 0 0 0 1.648 4.96c-.082.199-.119.427-.135.746-.027.538.424.975.962.975v0a1.625 1.625 0 0 1 0 3.25c-.82 0-.992.796-.975 1.194 0 .401 0 1.75 1.625 1.75M8.756 13.333 6.937 15 5.12 13.333M6.938 8.563v6.186" /></svg>;
}
;